var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChechRepublic2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chech_republic@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-70.000000, -621.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "Chech_republic"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 551.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.92,0.55 L6.65,0.55 C3.13746899,0.55 0.29,3.39746806 0.29,6.90999791 L0.29,24.5499921 L70.29,24.5499921 L70.29,6.90999791 C70.2900021,5.22148755 69.61856,3.60227988 68.423665,2.40926103 C67.2287699,1.21624218 65.6085088,0.547345109 63.92,0.55 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.28,41.18 C0.28,44.692531 3.12746899,47.54 6.64,47.54 L63.92,47.54 C67.432531,47.54 70.28,44.692531 70.28,41.18 L70.28,24.55 L0.28,24.55 L0.28,41.18 Z",
    id: "Shape",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.19,2.38 C0.971164836,3.57574529 0.286154249,5.21256006 0.29,6.92 L0.29,41.19 C0.291149023,42.9151958 0.995294766,44.5654245 2.24,45.76 L25.29,24.55 L2.19,2.38 Z",
    id: "Shape",
    fill: "#4758A9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChechRepublic2X);
export default __webpack_public_path__ + "static/media/Chech_republic@2x.bf19e7d43aa8371473308c475c57f05d.svg";
export { ForwardRef as ReactComponent };